<script setup>
    import { router } from '@inertiajs/vue3';
    import { ref } from 'vue';
    import CountUp from 'vue-countup-v3';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        totalCarbonForOrganisation: Object,
    });

    //calculate carbon savings
    const totalCarbonSavings = props.totalCarbonForOrganisation;

</script>

<template>

            <div class="text-center sm:w-full place-content-center">
                <div class="content-center rounded-full" style="background-color: #289b68; width: 5vw; height: 5vw; min-width: 150px; min-height: 150px; margin: 0 auto;">
                    <div class="text-2xl font-extrabold text-white">
                        <count-up
                            :end-val=totalCarbonSavings
                            :options="{
                                decimal: '.',
                                decimalPlaces: 2,
                                enableScrollSpy: true,
                                scrollSpyDelay: 1000,
                                scrollSpyOnce: true
                            }"
                        >
                        </count-up>
                    </div>
                    <p class="pt-1 text-sm font-bold text-white" v-html="$t('dashboard.widgets.carbon_savings.savings_append')"></p>
                </div>
                <p class="mt-2 text-xs" v-html="$t('dashboard.widgets.carbon_savings.savings_current_toolkit', {currentSavings: totalCarbonSavings})"></p>
            </div>

</template>
